import { FormSubtitle } from '@sravni/cosago-react-library/lib/components';
import cn from 'classnames';

import { PARTNERS_IDS } from 'constants/partners';

import styles from './FormStepDescription.module.scss';

type DescriptionProps = { disabled?: boolean };

export const DefaultDescription: FC<DescriptionProps> = ({ disabled, children }) => (
  <FormSubtitle
    className={cn('h-preline', {
      [styles.descriptionDisabled]: disabled,
    })}
  >
    {children}
  </FormSubtitle>
);

const AvitoDescription: FC<DescriptionProps> = ({ children, className, disabled, ...otherProps }) => {
  return (
    <FormSubtitle
      className={cn('h-preline', styles.avitoStepDescription, className, {
        [styles.descriptionDisabled]: disabled,
      })}
      {...otherProps}
    >
      {children}
    </FormSubtitle>
  );
};

export const FormStepDescriptionConfig: Record<number, FC<DescriptionProps>> = {
  [PARTNERS_IDS.avito]: AvitoDescription,
} as const;
